export default __webpack_public_path__ + "static/media/milkshake.fd1d4fb9.jpg";